export const validate = (values) => {
  const errors = {
    discountAndTax: {}
  }
  if (values.qboNonAST && values.discountAndTax.taxAmount && !values.discountAndTax.qboTaxCodeId) {
    errors.discountAndTax.qboTaxCodeId = 'Required'
  }
  return errors
}
